import React, { useEffect, useState } from 'react'
import { useInView } from "react-intersection-observer";
import $ from 'jquery'
const About1 = () => {

    const { ref, inView, entry } = useInView({
        rootMargin: '0px 0px',
        threshold: 0,
        initialInView :false,
      });

      const [t,uset] = useState(0)
      const [k,usek] = useState(0)
    useEffect(() => {
console.log(inView)
       console.log(entry)
       
    },[ entry]  )



    return (
        <div ref={ref} className=' sticky  z-10  min-w-screen overflow-clip     ' >
            <div className=' h-full  min-w-full  flex justify-center items-center slide bg-black   ' data-section="about"  > 
            <div className='text-2xl paragraph h-full      md:text-6xl font-semibold  text-center p-[5%]   absolute z-[9999] slide w-full    ' id='bl' >
                <p className=' min-w-screen h-fit  p-10 md:p-0 text-2xl sm:text-4xl md:text-5xl xl:text-6xl md:justify-center md:items-center  flex-wrap  text-justify   '  >



                  <span>
                    I'm a full-stack developer who loves crafting engaging web experiences by harmoniously
                    blending intuitive designs with robust code. With a
                    passion for innovation, I thrive on developing
                    cutting-edge solutions that push the boundaries of
                    what's possible in the ever-evolving tech
                    landscape.ContinuousIy exploring new technologies
                    to stay ahead of the curve.            
                    </span>  
                </p>

            </div>
            </div>
        </div>
    )
}

export default About1